import React, { useContext, useEffect } from "react";
import { ReactComponent as QuestionIcon } from "../../img/Question_icon.svg";
import {
    CancelLink,
    Row,
    StyledBadge,
    StyledCardBilled,
    StyledCardContainer,
    StyledCardHeader,
    StyledCardPrice,
    StyledCardSessions,
    StyledCardTitle,
    StyledCrossedPrice, StyledMonth, StyledPrice
} from "./plans.style";
import Tooltip from "../utils/Tooltip";
import FixelDataContext from "../../context/FixelDataContext";
import LinkButton from "../linkButton/LinkButton.component";
import {useHistory} from "react-router-dom";

const PlanCard = ({ plan, applyCoupon, coupon }) => {
  const { fullFixelData, setShowSpinner } = useContext(FixelDataContext);
  const {id} = plan;
  const history = useHistory();

  const planType = fullFixelData?.plan?.type.toLowerCase();
  const isActivePlan = fullFixelData.plan && fullFixelData.plan.state.toLowerCase() === "active";
  const isCurrentActivePlan =
    planType &&
    planType.toLowerCase() === plan.name.replace(" ", "_").toLowerCase() &&
    fullFixelData.plan &&
    fullFixelData.plan.state &&
    fullFixelData.plan.state.toLowerCase() === "active";

  const showOriginalPriceCrossed = applyCoupon && plan.originalPrice;
  const showActivePlanOriginalPriceCrossed =
        fullFixelData.plan &&
        fullFixelData.plan.price &&
        isCurrentActivePlan &&
        parseFloat(fullFixelData.plan.price) !== parseFloat(plan.price) &&
        !plan.originalPrice;
  const cantSubscribe = isCurrentActivePlan && !plan.originalPrice;

  useEffect(() => setShowSpinner(false), [setShowSpinner]);

  return (
      <StyledCardContainer>
          {isCurrentActivePlan && <StyledBadge>ACTIVE</StyledBadge>}
          <StyledCardHeader>
              <StyledCardTitle>{plan.name}</StyledCardTitle>
              <StyledCardPrice>
                  <Row>
                      {showOriginalPriceCrossed ? (
                          <StyledCrossedPrice>${plan.originalPrice}</StyledCrossedPrice>
                      ) : null}
                      {showActivePlanOriginalPriceCrossed ? (
                          <StyledCrossedPrice>${plan.price}</StyledCrossedPrice>
                      ) : null}
                      <StyledPrice>
                          ${cantSubscribe ? Math.round(fullFixelData.plan.price * 100) / 100 : plan.price}
                      </StyledPrice>
                      <span>/</span>
                      <StyledMonth>month</StyledMonth>
                  </Row>
              </StyledCardPrice>

              <StyledCardBilled>Billed monthly</StyledCardBilled>
          </StyledCardHeader>
          <StyledCardSessions>
              <span>{plan.terms}</span>
              <Tooltip content="A session is the period of time a user is actively engaged with your website (similar to Google Analytics sessions).">
                  <QuestionIcon />
              </Tooltip>
          </StyledCardSessions>
          <LinkButton type="button" value={id} disabled={isActivePlan && isCurrentActivePlan} to={{pathname: `plans/checkout/${plan.arrayId}`,plan: plan, coupon: coupon}}>
              {(isActivePlan && isCurrentActivePlan) || planType === "trial" || !isActivePlan ? "subscribe" : "change plan"}
          </LinkButton>
          {isActivePlan && isCurrentActivePlan?
              <CancelLink onClick={() => history.push(`/plans/cancel/${plan.arrayId}`)}>
                  cancel plan
              </CancelLink>
          :null}
      </StyledCardContainer>
  );
}
export default PlanCard;